export default __webpack_public_path__ + "static/media/bg3.c618310a.jpg";